export default __webpack_public_path__ + "static/bannerImg-63a243c1c45beda03c7323a342dc7d32.png";